<div class="brand-search-container">
    <!-- 搜索框 -->
    <!-- <div class="input-row">
        <nz-input-group [nzSuffix]="suffixTpl">
            <input type="text" nz-input placeholder="请输入车型名称查询" [(ngModel)]="searchValue"
                (ngModelChange)="onSearch()" />
        </nz-input-group>
    </div>
    <ng-template #suffixTpl>
        <i nz-icon nzType="search"></i>
    </ng-template> -->
    <app-multi-search placeholder="请输入品牌或车型名称查询" [selectedItems]="mySelections"
        (selectedIndexChange)="onSelectedIndexChanged($event)" (selectedObjectChange)="onSelectionsChanged($event)">
    </app-multi-search>
    <nz-spin [nzSpinning]="loading" nzTip="loading...">
        <div *ngIf="isSearchByBrandVisible">
            <!-- <div class="hot-brands">
                <h3 style="font-weight: bold;">热搜品牌</h3>
                <div class="brands-grid">
                    <div class="brand-icon brand-case" *ngFor="let car of hotBrands"
                        [class.selected]="selectedBrandId === car?.id" (click)="selectHotBrand(car)">
                        <div class="car-brand-item">
                            <span class="brand-name">{{car?.brand}}</span>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="brand-list-wrapper">
                <!-- 左侧品牌列表 -->
                <div #brandList class="brand-list">
                    <div class="hot-brands">
                        <h3 style="font-weight: bold;">热搜品牌</h3>
                        <div class="brands-grid">
                            <div class="brand-icon brand-case" *ngFor="let car of hotBrands"
                                [class.selected]="selectedBrandId === car?.id" (click)="selectHotBrand(car)">
                                <div class="car-brand-item">
                                    <span class="brand-name">{{car?.brand}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngFor="let letter of brandLetters">
                        <ng-container *ngIf="letter !== '热'">
                            <div class="brand-letter" [id]="'letter-' + letter">
                                {{ letter }}
                            </div>

                            <div class="brand-item" *ngFor="let brand of brandsByLetter[letter]"
                                (click)="selectBrand(brand)">
                                {{ brand.brandName }}
                            </div>
                        </ng-container>
                    </ng-container>
                </div>

                <!-- 右侧字母导航 -->
                <div class="letter-nav">
                    <div *ngFor="let letter of brandLetters" class="letter-item"
                        [class.active]="letter === activeLetter" (click)="scrollToLetter(letter)">
                        {{ letter }}
                    </div>
                </div>
            </div>
        </div>
        <div class="page-container" *ngIf="isSearchByTypeVisible">
            <div class="main-body">
                <div class="sidebar">
                    <div *ngFor="let man of allFilteredSeries" class="manufacturer-group">
                        <div class="man-title" (click)="toggleManufacturer(man)">
                            <span>{{ man.manufacturer }}</span>
                            <span class="arrow" [class.down]="man.expanded">▼</span>
                        </div>
                        <ul class="series-list" *ngIf="man.expanded">
                            <li *ngFor="let series of man.modelClassList"
                                [class.active]="(currentSeries?.modelClass === series.modelClass) && (currentSeries?.manufacturer === series.manufacturer)"
                                (click)="selectSeries(series)">
                                {{ series.modelClass }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content">
                    <div class="content-header">
                        选择型号
                    </div>
                    <div class="model-list" *ngIf="currentSeries">
                        <div *ngFor="let model of allFilteredModels" class="model-item">
                            <span class="model-name">
                                {{ model.modelName }}
                            </span>
                            <div class="checkbox-wrapper">
                                <input type="checkbox" [checked]="model.selected" (change)="toggleModel(model)">
                            </div>
                        </div>
                        <div *ngIf="allFilteredModels.length === 0" class="no-data">
                            暂无车型
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-container" [hidden]="!isSearchByYearVisible">
            <div class="main-body">
                <div class="sidebar">
                    <div class="manufacturer-group">
                        <div class="man-title">
                            <span>选择年款</span>
                        </div>
                        <ul class="series-list">
                            <li *ngFor="let year of allFilteredYears" [class.active]="year === selectedYear"
                                (click)="handleSelectYear(year)">
                                {{ year }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content">
                    <div class="content-header">
                        选择车型（可多选）
                    </div>
                    <div class="model-list" [hidden]="!selectedYear" #scrollContainer>
                        <div *ngFor="let carModel of allCarModels" class="model-item">
                            <div class="model-name">
                                <span>{{ carModel.carFullInfo }}</span>
                                <span class="engine-code">
                                    发动机代码：{{ carModel.engineCode }}
                                </span>
                            </div>
                            <div class="checkbox-wrapper">
                                <input type="checkbox" [checked]="isSelected(carModel)"
                                    (change)="toggleDisplacement(carModel)" />
                            </div>
                        </div>
                        <div class="loading" *ngIf="loadingMore">
                            <nz-spin nzSimple></nz-spin>
                            <span class="loading-text">加载中...</span>
                        </div>
                        <div class="no-more" *ngIf="!loadingMore && !hasMore && allCarModels.length > 0">
                            没有更多车型了
                        </div>
                        <div #loadMoreAnchor class="load-more-anchor"></div>
                        <div class="no-data" *ngIf="!loadingMore && allCarModels.length === 0">
                            暂无车型
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer" *ngIf="selectedYear">
                <div class="footer-left">
                    <label nz-checkbox class="select-all-label" [(ngModel)]="isAllSelected"
                        [nzIndeterminate]="indeterminate" (ngModelChange)="toggleSelectAll($event)">
                        <span>全选</span>
                    </label>
                    <span class="cancel-btn" (click)="clearSelection()">
                        取消选择
                    </span>
                </div>
                <button class="next-btn" (click)="nextStep()">
                    下一步
                </button>
            </div>
        </div>
    </nz-spin>
</div>
